import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  bookingResumeMatchesUser,
  clearBookingResumeDraft,
  getBookingResumeDraft,
  restoreBookingFlowSession,
} from '../../util/bookingResume';

const BookingResumeManager = () => {
  const currentUser = useSelector(state => state.user.currentUser);
  const history = useHistory();
  const location = useLocation();
  const processedDraftRef = useRef(null);

  useEffect(() => {
    if (!currentUser?.id?.uuid) {
      return;
    }

    const draft = getBookingResumeDraft();
    if (!draft) {
      return;
    }

    if (!bookingResumeMatchesUser(draft, currentUser)) {
      clearBookingResumeDraft();
      return;
    }

    const restoreStage = draft.restoreStage || 'reservation-details';
    const targetPath = `/l/${draft.listingSlug}/${draft.listingId}/${restoreStage}`;
    const draftKey = `${draft.createdAt}:${draft.listingId}`;
    if (processedDraftRef.current !== draftKey) {
      processedDraftRef.current = draftKey;
      restoreBookingFlowSession(draft);
    }

    // AuthenticationPage can also redirect after login. Keep the booking route
    // authoritative until target page consumes and clears the draft.
    if (location.pathname !== targetPath) {
      history.replace(targetPath, {
        bookingType: draft.bookingType,
        userType: draft.userType,
        userId: draft.userId,
        bookingData: draft.bookingData,
        guestDetails: draft.guestDetails,
        restoreBooking: true,
      });
    }
  }, [currentUser, history, location.pathname]);

  return null;
};

export default BookingResumeManager;
